import type { ReactNode, MouseEvent, FC } from 'react';
import { forwardRef } from 'react';

import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import type { ButtonVariant } from './ButtonVariant';
import { StyledButton, StyledGainAccessButton } from './styles';

export type ButtonProps = {
  children?: ReactNode;
  variant?: ButtonVariant;
  onClick?(event: MouseEvent<HTMLButtonElement>): void;
  className?: string;
  disabled?: boolean;
  isLoading?: boolean;
  isActive?: boolean;
  indicator?: boolean;
  'data-automation'?: string;
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const { children, variant = 'primary', onClick, className, disabled, isLoading, isActive } = props;
  return (
    <StyledButton
      variant={variant}
      onClick={onClick}
      className={className}
      disabled={disabled}
      data-automation={props['data-automation']}
      isLoading={isLoading}
      isActive={isActive}
      indicator={props.indicator}
      ref={ref}
      isHoverDisabled={!onClick}
    >
      {children}
    </StyledButton>
  );
});

export const GainAccessButton: FC<ButtonProps> = (props) => {
  const { t } = useTranslation();

  return (
    <StyledGainAccessButton variant="trial" {...props}>
      <SWReactIcons iconName="sparkles-gray" size="18px" iconColor={colorsPalettes.carbon[0]} />
      {props.children ?? t('common.gain_access')}
    </StyledGainAccessButton>
  );
};
